import { Box, Button, FormControlLabel, IconButton, MenuItem, Radio, RadioGroup, Select, SelectChangeEvent, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs } from "@mui/material";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import { useState } from "react";
import AddIcon from '@mui/icons-material/Add';
import React from "react";
import SwitchToggle from "../../components/SwitchToggle";
import RewardAuditLogTable from "../../features/manageRewards/rewardAuditLogTable";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageRewards = () => {

  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [valueTabs, setValueTabs] = useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const [Status, setStatus] = React.useState('default');
  const [Sort, setSort] = React.useState('default');

  const [rewards] = useState([
    {
      id: 1,
      title: "Follow Us & Enjoy",
      type: "Discount",
      value: "20%",
      points: "100",
      validity: "01-Sep-2025 - 30-Sep-2025",
      category: "Books",
      maxRedemption: "5 times",
      created: "01-Sept-2025",
    },
    {
      id: 2,
      title: "Follow Us & Enjoy",
      type: "Cashback",
      value: "$5",
      points: "200",
      validity: "05-Sep-2025 - 20-Sep-2025",
      category: "Uniforms",
      maxRedemption: "5 times",
      created: "01-Sept-2025",
    },
    {
      id: 3,
      title: "Follow Us & Enjoy",
      type: "Discount",
      value: "10%",
      points: "50",
      validity: "01-Sep-2025 - 15-Sep-2025",
      category: "Stationary",
      maxRedemption: "5 times",
      created: "01-Sept-2025",
    },
  ]);

  return (
    <>
      <div className="main_title">
        <h1>Rewards & Offers Management</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Rewards & Offers Management
        </p>
      </div>

      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="Rewards & Offers" {...a11yProps(0)} />
              <Tab label="Referral Reward Earning" {...a11yProps(1)} />
              <Tab label="Audit Log" {...a11yProps(2)} />
            </Tabs>
          </Box>
        </div>
      </div>

      <div className="cards">
        <CustomTabPanel value={valueTabs} index={0}>
          <div className="table_header">
            <div className="left_s">
              <SearchBar
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setSearchTerm}
                placeholder="Search..."
              />
              <div className="form">
                <Select
                  fullWidth
                  value={Status}
                  onChange={(e: SelectChangeEvent) =>
                    setStatus(e.target.value)
                  }>
                  <MenuItem disabled value="default">Select Visibility</MenuItem>
                  <MenuItem value="All">All</MenuItem>
                  <MenuItem value="Show">Enabled</MenuItem>
                  <MenuItem value="Hide">Disabled</MenuItem>
                </Select>
                <Select
                  fullWidth
                  value={Sort}
                  onChange={(e: SelectChangeEvent) =>
                    setSort(e.target.value)
                  }>
                  <MenuItem disabled value="default">Sort Order</MenuItem>
                  <MenuItem value="1">Newest First</MenuItem>
                  <MenuItem value="2">Oldest First</MenuItem>
                </Select>
              </div>
            </div>
            <div className="right_s">
              <Button className="btn btn_primary" onClick={() => navigate("/manage-rewards/add")}><AddIcon /> Add Rewards & Offers</Button>
            </div>
          </div>
          <TableContainer className="table_container">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Reward Title</TableCell>
                  <TableCell>Reward Type</TableCell>
                  <TableCell>Required Points</TableCell>
                  <TableCell>Validity Period</TableCell>
                  <TableCell>Category</TableCell>
                  <TableCell>Max Redemption</TableCell>
                  <TableCell>Created Date</TableCell>
                  <TableCell>Visibility</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rewards.map((reward) => (
                  <TableRow hover key={reward.id}>
                    {/* Image */}
                    <TableCell>
                      <a
                        href="/manage-rewards/detail"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate("/manage-rewards/detail");
                        }}
                        className="user_block click_action"
                      >
                        <figure className="no_radius"><img src="/static/images/placeholder.png" alt="Images" /></figure>
                        <p>
                          <b>{reward.title}</b>
                        </p>
                      </a>
                    </TableCell>

                    {/* Reward Type + Value */}
                    <TableCell>
                      <span className="status_btn c_info no_wrap">
                        {reward.type}: {reward.value}
                      </span>
                    </TableCell>

                    {/* Loyalty Points */}
                    <TableCell>{reward.points}</TableCell>

                    {/* Validity */}
                    <TableCell>{reward.validity}</TableCell>

                    {/* Category */}
                    <TableCell>{reward.category}</TableCell>

                    {/* Max Redemption */}
                    <TableCell>{reward.maxRedemption}</TableCell>

                    {/* Created Date */}
                    <TableCell>{reward.created}</TableCell>

                    {/* Visibility */}
                    <TableCell><SwitchToggle /></TableCell>

                    {/* Actions */}
                    <TableCell>
                      <div className="table_actions v2">
                        <IconButton onClick={() => navigate("/manage-rewards/detail")}>
                          <img src="/static/images/eye_icon.svg" alt="" />
                        </IconButton>
                        <IconButton onClick={() => navigate("/manage-rewards/add")}>
                          <img src="/static/images/edit2_icon.svg" alt="" />
                        </IconButton>
                        <IconButton>
                          <img src="/static/images/trash2_icon.svg" alt="" />
                        </IconButton>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={1}>
          <form className="form" action="">
            <div className="section_title">
              <h2>Reward Eligibility Criteria</h2>
            </div>
            <div className="gap_p">
              <div className="control_group w_100">
                <RadioGroup
                  className="flex"
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue="registration"
                  name="radio-buttons-group"
                >
                  <FormControlLabel value="registration" control={<Radio />} label="By referred user registration" />
                  <FormControlLabel value="purchase" control={<Radio />} label="By the first purchase of the referred user" />
                </RadioGroup>
              </div>
            </div>
            <div className="form_btn">
              <Button className="btn btn_primary">Submit</Button>
            </div>
          </form>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={2}>
          <RewardAuditLogTable />
        </CustomTabPanel>
      </div>
    </>
  );
};

export default ManageRewards;
